var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 14,
  viewBox: "0 0 20 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A8B6CD",
  fillRule: "nonzero",
  d: "M.404 7.918h2.124v-2.64H.404v2.64zm0 5.28h2.124v-2.64H.404v2.64zm0-10.559h2.124V0H.404v2.64zm4.248 5.28H19.52v-2.64H4.652v2.64zm0 5.278H19.52v-2.64H4.652v2.64zM4.652 0v2.64H19.52V0H4.652z"
})));
export default __webpack_public_path__ + "teg/media/listing.0867073e.svg";
export { SvgComponent as ReactComponent };